import PropTypes from 'prop-types';
import React from 'react';

export const GreenToRedPositionsWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'GREEN_TO_RED_POSITIONS',
    category: 'Exit',
    type: 'Green to Red Positions',
    domain: 'Underlying',
  };
  const state = softOrder.state;
  //depending on state, either right direction pct is sent or retrace is sent
  const inRightDirectionPct = softOrder.inRightDirectionPct;
  const retracePct = softOrder.retracePct;
  const priceToBreak = softOrder.priceToBreak;

  return (
    <Component
      details={details}
      state={state}
      priceToBreak={priceToBreak}
      inRightDirectionPct={inRightDirectionPct}
      retracePct={retracePct}
      {...rest}
    />
  );
};

GreenToRedPositionsWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    inRightDirectionPct: PropTypes.any,
    priceToBreak: PropTypes.any,
    retracePct: PropTypes.any,
    state: PropTypes.any
  })
};


